"use strict";
var Observable_1 = require('../../Observable');
var let_1 = require('../../operator/let');
Observable_1.Observable.prototype.let = let_1.letProto;
Observable_1.Observable.prototype.letBind = let_1.letProto;
//# sourceMappingURL=let.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2032928750/src/~/rxjs/add/operator/let.js
// module id = ykQW
// module chunks = 6